import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PostMerchantFormRequest } from '../shared/PostMerchantRequestForm';
import { Observable } from 'rxjs';
import { LogMerchantFileKey } from '../components/utils/models/logmerchantfilekey';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private http: HttpClient, private environmentService: EnvironmentService) { }

  UploadFile(file : File) : Observable<any>{
   
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    const headers = new HttpHeaders({
      'Accept': 'application/json'
      // Note: Angular automatically sets 'Content-Type': 'multipart/form-data' when FormData is used
    });

    return this.http.post<any>(this.environmentService.getConfig('BackendApi') + 'api/Files/upload', formData, { headers: headers });
  }

  LogMerchantFileKey(fileLogRequest : LogMerchantFileKey) : Observable<any>{

    return this
      .http
      .post<any>(this.environmentService.getConfig('BackendApi') + 'api/Files/LogMerchantFile', fileLogRequest);
  }

  GenerateFileUrl(fileguid : string) : Observable<any>{
   
    return this
          .http
          .get<any>(this.environmentService.getConfig('BackendApi') + `api/Files/generate-url?filename=${fileguid}`);
  }

  

}
